import React, { useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../helpers";
import { Link, useNavigate } from "react-router-dom";
import axios, { AxiosRequestHeaders } from "axios";
import { getAuth } from "../../../../app/modules/auth";
import SwitchStatus from "../../form/components/fields/SwitchStatus";
import { Pagination } from "../../pagination/Pagination";
import { BadgeStatus } from "../../badges/statusBadge";
import DeleteModal, {
  modalSettingsInterface,
} from "../../modals/delete/DeleteModal";
import { DropdownFilterTables } from "../../content/dropdown/DropdownFilterTables";
import { showErrorMessage } from "../../../helpers/MessagesHelper";
import DateFormat from "./../../format/DateFormat";
import Modal from "../../modals/Modal";
import { useStyleContext } from "../../../helpers/StyleContext";
import clsx from "clsx";
import BanModal from "../../modals/ban/BanModal";
import ColorIndicator from "../../color-indicators/ColorIndicator";
import SignedContractModal from "../../modals/signed-contract/SignedContract";
import DecimalNumberCents from "../../format/DecimalNumberCents";
import { Modal as BootstrapModal, Button, Form } from "react-bootstrap";

export interface columnsInterface {
  description: string;
  className: string;
  reference: string;
  type?: string;
  test_compliance?: boolean;
}

export interface actionsInterface {
  url: string;
  icon: string;
  title: string;
  type?: string;
}

export interface createButtonInterface {
  url: string;
  label: string;
  hideIcon?: boolean;
}

export interface filtersInterface {
  situationFilter?: boolean;
  pageFilter?: boolean;
}

type Props = {
  className: string;
  createButton?: createButtonInterface;
  backButton?: createButtonInterface;
  extraButton?: createButtonInterface;
  columns?: columnsInterface[];
  actions?: actionsInterface[];
  nameModule?: string;
  descriptionModule?: string;
  module: string;
  moduleData: string;
  operation?: string;
  customFilters?: filtersInterface;
  activeFilter?: string;
  setDashboardUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  initialSearch?: string;
  findDebtors?: boolean;
  checkPendencies?: boolean;
  customActionHandler?: (item: any, action: actionsInterface) => React.ReactNode;
  customColumnRenderers?: { [key: string]: (item: any) => React.ReactNode };
  extraParams?: Record<string, string | number | undefined>;
  headerToolbarContent?: React.ReactNode;
};

const containerMap: Record<string, string> = {
  "91f5167c34c400758115c2a6826ec2e3": "Administrador do Sistema",
  "deecad80a2b97f02377b213b3e8e2021": "Funcionários",
  "755b46b53cb5f23fc6c7f8fb807850a5": "Comissão Técnica",
  "8807d8ab4397779bf10e9f65873996ba": "Atletas",
  "3bd596d38e21735d4eb4448dc39a7644": "Associados",
  "89b33a5d8f6d610c43cdb54359bdc122": "Visitantes",
  "E2F7330728B5EACAEF4919EE42BD646D": "Patrocinadores",
};

const TablesWidget11: React.FC<Props> = ({
  className,
  nameModule,
  descriptionModule,
  createButton,
  backButton,
  extraButton,
  columns,
  actions,
  module,
  moduleData,
  operation,
  customFilters,
  activeFilter,
  setDashboardUpdate,
  initialSearch,
  findDebtors,
  checkPendencies,
  customActionHandler,
  customColumnRenderers,
  extraParams,
  headerToolbarContent,
}) => {
  const [data, setData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSignedContractModal, setShowSignedContractModal] = useState(false);
  const [selectedItemModal, setSelectedItemModal] = useState({});
  const { styleState } = useStyleContext();
  const [showPendencyModal, setShowPendencyModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [pendencies, setPendencies] = useState<any[]>([]);
  const [pendencyUser, setPendencyUser] = useState<any>(null);
  const [selectedPendency, setSelectedPendency] = useState<any>(null);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);

  const [paymentForm, setPaymentForm] = useState({
    discount: 0,
    interest: 0,
    paidAmount: 0,
  });

  const [pagination, setPagination] = useState({
    page: 1,
    amount: 10,
    itemsFound: 0,
    total: 0,
  });

  const [filters] = useState({
    status: "all",
    search: initialSearch || "",
  });

  const [modalSettings, setModalSettings] = useState<modalSettingsInterface>({
    itemId: 0,
    deleteItemDescriptionOrName: "",
    module,
    toBan: false,
  });

  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token;

  const operationHeader = operation && operation.includes('/')
    ? operation
    : `${operation ?? module}/find`;

  const findHeaders = {
    Authorization: `Bearer ${token}`,
    operation: operationHeader,
  };
  const navigate = useNavigate();

  const [statusFilter] = useState({
    active: true,
    inactive: true,
  });

  const extraParamsRef = useRef(extraParams);
  extraParamsRef.current = extraParams ?? undefined;

  const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((current, prop) => current?.[prop], obj);
  };

  const loadList = async (
    module: string,
    headers: AxiosRequestHeaders,
    targetPage?: number,
    extraParamsOverride?: Record<string, string | number | undefined>,
  ) => {
    let statusParam = "all";
    if (statusFilter.active && !statusFilter.inactive)
      statusParam = "available";
    if (!statusFilter.active && statusFilter.inactive)
      statusParam = "unavailable";
    if (!statusFilter.active && !statusFilter.inactive)
      statusParam = "available,unavailable";

    const pageToSend = targetPage ?? pagination.page;
    const urlPath = operation && operation.includes('/')
      ? operation
      : module;

    const mergedExtra = extraParamsOverride ?? extraParamsRef.current ?? {};
    const cleanExtra = Object.fromEntries(
      Object.entries(mergedExtra).filter(
        ([, v]) => v !== undefined && v !== "" && !Number.isNaN(v)
      )
    );

    return await axios
      .get(`${apiUrl}/${urlPath}`, {
        headers,
        params: {
          amount: pagination.amount,
          page: pageToSend,
          status: statusParam,
          role: activeFilter,
          finddebtors: findDebtors,
          ...(!!filters?.search ? { search: filters.search } : {}),
          ...cleanExtra,
        },
      })
      .then((response) => {
        let dataArray = null;

        if (response.data?.[moduleData] && Array.isArray(response.data[moduleData])) {
          dataArray = response.data[moduleData];
        }
        else if (Array.isArray(response.data)) {
          dataArray = response.data;
        }
        else if (Array.isArray(response.data?.data)) {
          dataArray = response.data.data;
        }
        else if (Array.isArray(response.data?.items)) {
          dataArray = response.data.items;
        }
        else if (response.data && typeof response.data === 'object') {
          const firstArrayKey = Object.keys(response.data).find(key =>
            Array.isArray(response.data[key]) && key !== 'page' && key !== 'amount' && key !== 'total'
          );
          if (firstArrayKey) {
            dataArray = response.data[firstArrayKey];
          }
        }

        setData(dataArray || []);

        setPagination({
          page: Number(response.data?.page) || 1,
          amount: Number(response.data?.amount) || pagination.amount,
          itemsFound: response.data?.[`${moduleData}`]?.length ?? dataArray?.length ?? 0,
          total: Number(response.data?.total) || dataArray?.length || 0,
        });
      })
      .catch((error) => {
        showErrorMessage(
          error?.response?.data?.error?.statusCode,
          error?.response?.data?.error?.message,
        );

        if (error?.response?.data?.error?.statusCode === 403) {
          navigate("/");
        }
      });
  };

  useEffect(() => {
    loadList(module, findHeaders, 1, extraParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter, pagination.amount, statusFilter, findDebtors, JSON.stringify(extraParams ?? {})]);

  useEffect(() => {
    if (selectedPendency) {
      const originalValue = Number(selectedPendency.value) || 0;
      const discount = Number(paymentForm.discount) || 0;
      const interest = Number(paymentForm.interest) || 0;

      const calculatedTotal = originalValue + interest - discount;

      setPaymentForm((prev) => ({
        ...prev,
        paidAmount: calculatedTotal > 0 ? calculatedTotal : 0,
      }));
    }
  }, [paymentForm.discount, paymentForm.interest, selectedPendency]);

  const handleShowDeleteModal = async (module: string, item: any) => {
    let field = "";
    item?.["name"]
      ? (field = "name")
      : item?.["first_name"]
      ? (field = "first_name")
      : item?.["address"]
        ? (field = "address")
        : item?.["bracelet_color_name"]
          ? (field = "bracelet_color_name")
          : (field = "description");

    setModalSettings({
      itemId: item?.["_id"],
      deleteItemDescriptionOrName: item?.[field],
      module,
    });

    if (checkPendencies) {
      try {
        const response = await axios.get(
          `${apiUrl}/companies/pendencies/${item["_id"]}`,
          {
            headers: findHeaders,
          },
        );

        if (response.data && response.data.hasPendencies) {
          setPendencies(response.data.pendencies || []);
          setPendencyUser(item);
          setShowPendencyModal(true);
          return;
        }
      } catch (error: any) {
        console.error(
          "Erro ao verificar pendências (seguindo fluxo normal):",
          error,
        );
      }
    }

    setShowDeleteModal(true);
  };

  const checkPendenciesAgain = async () => {
    if (!pendencyUser || !pendencyUser["_id"]) return;

    try {
      const response = await axios.get(
        `${apiUrl}/companies/pendencies/${pendencyUser["_id"]}`,
        {
          headers: findHeaders,
        },
      );

      if (response.data && response.data.hasPendencies) {
        setPendencies(response.data.pendencies || []);
      } else {
        setShowPendencyModal(false);
        setShowDeleteModal(true);
      }
    } catch (error: any) {
      console.error("Erro ao revalidar pendências:", error);
    }
  };

  const handleOpenPaymentModal = (pendency: any) => {
    setSelectedPendency(pendency);
    setPaymentForm({
      discount: 0,
      interest: 0,
      paidAmount: Number(pendency.value) || 0,
    });
    setShowPaymentModal(true);
  };

  const handleConfirmPayment = async () => {
    if (!selectedPendency || !pendencyUser) return;

    setIsLoadingPayment(true);
    try {
      await axios.post(
        `${apiUrl}/companies/pendencies/pay`,
        {
          _id_user: pendencyUser["_id"],
          pendencyId: selectedPendency.id,
          source: selectedPendency.rota,
          originalValue: selectedPendency.value,
          discount: paymentForm.discount,
          interest: paymentForm.interest,
          paidAmount: paymentForm.paidAmount,
        },
        {
          headers: findHeaders,
        },
      );

      setShowPaymentModal(false);
      await checkPendenciesAgain();
    } catch (error: any) {
      showErrorMessage(
        error?.response?.data?.statusCode || 500,
        error?.response?.data?.message || "Erro ao processar pagamento",
      );
    } finally {
      setIsLoadingPayment(false);
    }
  };

  const handleShowBanModal = (module: string, item: any, toBan: boolean) => {
    setModalSettings({
      itemId: item?.["_id"],
      deleteItemDescriptionOrName: `${item?.["first_name"]} ${item?.["last_name"]}`,
      module,
      toBan,
    });
    setShowBanModal(true);
  };

  const handleShowModal = (module: string, item: any) => {
    setSelectedItemModal(item);
    setModalSettings({
      itemId: item?.["_id"],
      module: module,
    });
    setShowModal(true);
  };

  const handleShowSignedContractModal = (module: string, item: any) => {
    let field = "";
    item?.["name"]
      ? (field = "name")
      : item?.["first_name"]
        ? (field = "first_name")
        : item?.["address"]
          ? (field = "address")
          : item?.["bracelet_color_name"]
            ? (field = "bracelet_color_name")
            : (field = "description");
    setModalSettings({
      itemId: item?.["_id"],
      deleteItemDescriptionOrName: item?.[field],
      module,
    });
    setShowSignedContractModal(true);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
    setShowBanModal(false);
    setShowModal(false);
    setShowSignedContractModal(false);
    setShowPendencyModal(false);
    setShowPaymentModal(false);
  };

  return (
    <div
      className={`card ${className}`}
      key={descriptionModule}
      style={{
        backgroundColor: styleState.secondary_color,
        color: styleState.secondary_text_color,
      }}
    >
      <div className="card-header border-0 pt-5 d-flex flex-wrap justify-content-between align-items-end w-100" id="header-table">
        <h3
          className="card-title align-items-start flex-column flex-grow-1 me-3"
          id="title-header"
        >
          <span
            className={clsx("card-label fw-bold fs-3 mb-1", {
              "card-label": !styleState.secondary_text_color,
            })}
            style={{ color: styleState?.secondary_text_color }}
          >
            {nameModule}
          </span>
          <span
            className={clsx("mt-1 fw-semibold fs-7", {
              "text-muted": !styleState.secondary_text_color,
            })}
            style={{ color: styleState?.secondary_text_color }}
          >
            {descriptionModule}
          </span>
        </h3>
        <div className="card-toolbar flex-shrink-0">
          {headerToolbarContent}
          {extraButton && (
            <Link
              to={extraButton.url || ""}
              className={clsx("btn btn-sm me-3", {
                "btn-light-primary": !styleState.secondary_text_color,
                "text-hover-primary bg-hover-light":
                  styleState.secondary_text_color,
              })}
              style={{
                backgroundColor: styleState?.secondary_text_color,
                color: styleState?.secondary_color,
              }}
            >
              {!extraButton.hideIcon && (
                <KTSVG
                  path="/media/icons/duotune/arrows/arr076.svg"
                  className="svg-icon-2"
                  color={styleState.secondary_color}
                />
              )}{" "}
              {extraButton.label}
            </Link>
          )}
          {createButton && (
            <Link
              to={createButton?.url || ""}
              className={clsx("btn btn-sm me-1", {
                "btn-light-primary": !styleState.secondary_text_color,
                "text-hover-primary bg-hover-light":
                  styleState.secondary_text_color,
              })}
              style={{
                backgroundColor: styleState?.secondary_text_color,
                color: styleState?.secondary_color,
              }}
            >
              {!createButton.hideIcon && (
                <KTSVG
                  path="/media/icons/duotune/arrows/arr075.svg"
                  className="svg-icon-2"
                  color={styleState.secondary_color}
                />
              )}{" "}
              {createButton?.label}
            </Link>
          )}
          <button
            type="button"
            className={clsx("btn btn-sm btn-icon", {
              "btn-light-primary": !styleState.secondary_text_color,
              "text-hover-primary bg-hover-light":
                styleState.secondary_text_color,
            })}
            style={{ backgroundColor: styleState?.secondary_text_color }}
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-flip="top-end"
          >
            <KTSVG
              path="/media/icons/duotune/general/gen024.svg"
              className="svg-icon-2"
              color={styleState?.secondary_color}
            />
          </button>

          <DropdownFilterTables
            pagination={pagination}
            loadList={loadList}
            module={module}
            findHeaders={findHeaders}
            filters={filters}
            pageFilter={customFilters?.pageFilter ?? true}
            situationFilter={customFilters?.situationFilter ?? true}
          />
        </div>
      </div>

      <div className="card-body py-3">
        <div className="table-responsive">
          <table
            className="table align-middle gs-0 gy-4 w-100"
            key="table-id"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <thead>
              <tr
                className={clsx("fw-bold", {
                  "text-muted bg-light": !styleState.secondary_text_color,
                })}
                style={{
                  backgroundColor: styleState?.secondary_text_color,
                  color: styleState?.secondary_color,
                }}
              >
                {columns?.map((column, columnIndex) => (
                  <th key={`th-${columnIndex}`} className={column.className}>
                    {column?.description}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((item: any, itemIndex) => {
                const isSystemDefault = item.default_system === true || item.default_system === 1 || item.default_system === "true";

                return (
                  <tr key={`tr-${itemIndex}`}>
                    {columns?.map((column, columnIndex) => {
                      return (
                        <td
                          key={`td-${columnIndex}`}
                          className={
                            column.reference === "actions"
                              ? "min-w-420px"
                              : column.reference === "_id"
                              ? "ps-4"
                              : ""
                          }
                        >
                          {column.type === "image" && (
                            <div className="symbol symbol-35px w-20 symbol-circle me-5">
                              {item[column.reference] ? (
                                <img
                                  src={
                                    item[column.reference].toString().startsWith('data:image') 
                                      ? item[column.reference] 
                                      : `${process.env.REACT_APP_AWS_URL}/${item[column.reference]}`
                                  }
                                  alt={item.first_name || item.name || "Imagem"}
                                  style={{
                                    objectFit: "cover",
                                    border: "5px solid #E4E6EF",
                                    padding: "2px",
                                  }}
                                  onError={(e) => {
                                    (e.target as HTMLImageElement).src =
                                      "/media/avatars/blank.png";
                                  }}
                                />
                              ) : (
                                <div
                                  className="symbol-label fs-2 bg-light-primary text-primary fw-bold symbol-30px"
                                  style={{
                                    objectFit: "cover",
                                    border: "5px solid #E4E6EF",
                                    padding: "0px",
                                    margin: "0px",
                                  }}
                                >
                                  {(item.first_name || item.name || "U")?.charAt(0)}
                                </div>
                              )}
                            </div>
                          )}
                          {column.reference === "user_roles" && (
                            <span className="fw-bold text-dark mb-1 fs-6">
                              {item.roles
                                ?.map(
                                  (userRole: any) => userRole.role?.description,
                                )
                                .join(", ") || "Nenhuma"}
                            </span>
                          )}
                          {(!item["banned"] || item["banned"] === false) &&
                            column.reference === "status" &&
                            column.type !== "contract-status" &&
                            (column.type !== "status-text" ? (
                              isSystemDefault ? (
                                <span className="badge badge-light-success fw-bold">Padrão do Sistema</span>
                              ) : (
                                <SwitchStatus
                                  key={`${item["_id"]}-${columnIndex}`}
                                  active={
                                    item["status"]?.["description"] ===
                                    "available"
                                  }
                                  itemId={item["_id"]}
                                  module={module}
                                  token={token}
                                  apiUrl={apiUrl}
                                  setDashboardUpdate={setDashboardUpdate}
                                />
                              )
                            ) : (
                              <BadgeStatus
                                description={item["status"]?.["description"]}
                                key={`badge-${columnIndex}`}
                              />
                            ))}
                          {column.reference === "status" &&
                            column.type === "contract-status" && (
                              <BadgeStatus
                                description={item["status"]?.["description"]}
                              />
                            )}
                          {column.reference === "_container_id" && (
                            <span
                              className={clsx("fw-bold mb-1 fs-6", {
                                "text-dark": !styleState.secondary_text_color,
                              })}
                              style={{ color: styleState?.secondary_text_color }}
                            >
                              {containerMap[item._container_id] || item._container_id || "-"}
                            </span>
                          )}
                          {item["banned"] &&
                            column.reference === "user-status" && (
                              <BadgeStatus description={"banned"} />
                            )}
                          {!item["banned"] &&
                            item["compliance"] &&
                            !item["overdue"] &&
                            column.reference === "user-status" && (
                              <SwitchStatus
                                key={`${item["_id"]}-${columnIndex}`}
                                active={
                                  item["status"]?.["description"] ===
                                  "available"
                                }
                                itemId={item["_id"]}
                                module={module}
                                token={token}
                                apiUrl={apiUrl}
                                setDashboardUpdate={setDashboardUpdate}
                              />
                            )}
                          {column.type === "color" && (
                            <ColorIndicator
                              hexColor={getNestedValue(item, column.reference)}
                              key={`color-indicator-${columnIndex}`}
                            />
                          )}
                          {column.reference === "actions" &&
                            actions?.map((action, actionIndex) => {
                              if (isSystemDefault && action.type === "delete") {
                                return null;
                              }
                              if (isSystemDefault && action.type === "edit") {
                                return null;
                              }

                              return action.type === "custom" && customActionHandler ? (
                                <React.Fragment key={actionIndex}>
                                  {customActionHandler(item, action)}
                                </React.Fragment>
                              ) : (
                                <div
                                  className="d-inline-block me-1 mb-1"
                                  key={actionIndex}
                                >
                                  <Link
                                    to={
                                      action.type === "link"
                                        ? item["_id"] + action.url
                                        : action.type === "edit"
                                          ? action.url + item["_id"]
                                          : "#"
                                    }
                                    onClick={(e) => {
                                      if (
                                        action.type === "edit" ||
                                        action.type === "link"
                                      )
                                        return;
                                      e.preventDefault();
                                      if (action.type === "delete")
                                        handleShowDeleteModal(module, item);
                                      if (action.type === "ban")
                                        handleShowBanModal(
                                          module,
                                          item,
                                          !item.banned,
                                        );
                                      if (action.type === "modal")
                                        handleShowModal(module, item);
                                      if (
                                        action.type ===
                                        "upload_signed_contract_modal"
                                      )
                                        handleShowSignedContractModal(
                                          module,
                                          item,
                                        );
                                    }}
                                    className={clsx(
                                      "btn btn-icon btn-sm w-30px h-30px",
                                      {
                                        "btn-bg-light btn-active-color-primary":
                                          !action.type || action.type === "edit",
                                        "btn-active-color-danger":
                                          action.type === "delete" ||
                                          (action.type === "ban" && !item.banned),
                                        "btn-active-color-success":
                                          action.type === "ban" && item.banned,
                                      },
                                    )}
                                    style={{ border: "1px solid #8c8e96" }}
                                    title={action.title}
                                  >
                                    <KTSVG
                                      path={
                                        action.type === "ban"
                                          ? item.banned
                                            ? "/media/icons/duotune/arrows/arr016.svg"
                                            : "/media/icons/duotune/arrows/arr015.svg"
                                          : action.icon
                                      }
                                      className="svg-icon-4"
                                      color={styleState?.secondary_color}
                                    />
                                  </Link>
                                </div>
                              );
                            })}
                          {column.reference === "company" && (
                            <span
                              className={clsx(
                                "fw-bold text-hover-primary mb-1 fs-6",
                                {
                                  "text-dark": !styleState.secondary_text_color,
                                }
                              )}
                              style={{
                                color: styleState?.secondary_text_color,
                              }}
                              key={`${column.type}-${columnIndex}`}
                            >
                              {item["company"]?.["name"]}
                            </span>
                          )}
                          {customColumnRenderers && customColumnRenderers[column.reference] ? (
                            <React.Fragment key={`custom-${column.reference}-${columnIndex}`}>
                              {customColumnRenderers[column.reference](item)}
                            </React.Fragment>
                          ) : column.type === "date" && (
                            <span
                              className={clsx(
                                "fw-bold text-hover-primary mb-1 fs-6",
                                {
                                  "text-dark": !styleState.secondary_text_color,
                                }
                              )}
                              style={{
                                color: styleState?.secondary_text_color,
                              }}
                              key={`${column.type}-${columnIndex}`}
                            >
                              <DateFormat
                                date={getNestedValue(item, column.reference)}
                              />
                            </span>
                          )}
                          {column.type === "decimal" && (
                            <span
                              className={clsx(
                                "fw-bold text-hover-primary mb-1 fs-6",
                                {
                                  "text-dark": !styleState.secondary_text_color,
                                }
                              )}
                              style={{
                                color: styleState?.secondary_text_color,
                              }}
                              key={`${column.type}-${columnIndex}`}
                            >
                              <DecimalNumberCents
                                value={getNestedValue(item, column.reference)}
                                prefix="R$ "
                              />
                            </span>
                          )}
                          {column.reference === "user_name" && (
                            <span
                              className={clsx(
                                "fw-bold text-hover-primary mb-1 fs-6",
                                {
                                  "text-dark": !styleState.secondary_text_color,
                                }
                              )}
                              style={{
                                color: styleState?.secondary_text_color,
                              }}
                              key={`user-name-${columnIndex}`}
                            >
                              {getNestedValue(item, "caixa.user_id")}
                            </span>
                          )}
                          {column.reference !== "actions" &&
                            column.type !== "image" &&
                            column.reference !== "status" &&
                            column.reference !== "_container_id" &&
                            column.reference !== "user_roles" &&
                            column.reference !== "company" &&
                            column.reference !== "user_name" &&
                            column.type !== "color" &&
                            column.type !== "decimal" &&
                            column.type !== "date" && (
                              <span
                                className={clsx(
                                  `fw-bold ${column?.test_compliance &&
                                    (!item["compliance"] || item["overdue"])
                                    ? "text-danger text-hover-danger"
                                    : "text-hover-primary"
                                  } mb-1 fs-6`,
                                )}
                                style={{
                                  color: styleState?.secondary_text_color,
                                }}
                              >
                                {getNestedValue(item, column.reference)}
                              </span>
                            )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <DeleteModal
            modalSettings={modalSettings}
            showModal={showDeleteModal}
            setShowModal={setShowDeleteModal}
            handleClose={handleClose}
            loadList={loadList}
            setDashboardUpdate={setDashboardUpdate}
          />
          <SignedContractModal
            modalSettings={modalSettings}
            showModal={showSignedContractModal}
            setShowModal={setShowSignedContractModal}
            handleClose={handleClose}
            loadList={loadList}
            setDashboardUpdate={setDashboardUpdate}
          />
          <BanModal
            modalSettings={modalSettings}
            showModal={showBanModal}
            setShowModal={setShowBanModal}
            handleClose={handleClose}
            loadList={loadList}
          />
          <Modal
            showModal={showModal}
            item={selectedItemModal}
            setShowModal={setShowModal}
            handleClose={handleClose}
            module={module}
            setDashboardUpdate={setDashboardUpdate}
          />

          <BootstrapModal
            show={showPendencyModal}
            onHide={() => setShowPendencyModal(false)}
            centered
            size="lg"
          >
            <BootstrapModal.Header
              closeButton
              className="bg-danger text-white pt-2 pb-2"
            >
              <BootstrapModal.Title>Exclusão Bloqueada</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body className="pb-0">
              <div className="alert alert-dismissible bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-0">
                <KTSVG
                  path="/media/icons/duotune/general/gen044.svg"
                  className="svg-icon-2hx svg-icon-danger me-4 mb-5 mb-sm-0"
                />
                <div className="d-flex flex-column pe-0 pe-sm-10">
                  <h5 className="mb-1">Existem pendências financeiras!</h5>
                  <span>
                    O usuário <strong>{pendencyUser?.first_name}</strong> não
                    pode ser excluído pois possui débitos em aberto.
                  </span>
                </div>
              </div>

              {pendencies && pendencies.length > 0 && (
                <div className="table-responsive p-0">
                  <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 pt-0 mt-0">
                    <thead>
                      <tr className="fw-bold text-muted">
                        <th className="fs-6">Descrição</th>
                        <th className="fs-6">Valor</th>
                        <th className="fs-6">Vencimento</th>
                        <th className="text-end fs-6">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendencies.map((pendency: any, idx: number) => (
                        <tr key={idx}>
                          <td className="fs-6">
                            {pendency.description || "Débito em aberto"}
                          </td>
                          <td className="text-danger fw-bold fs-6">
                            <DecimalNumberCents
                              value={pendency.value}
                              prefix="R$ "
                            />
                          </td>
                          <td className="fs-6">
                            <DateFormat date={pendency.due_date} />
                          </td>
                          <td className="text-end">
                            {pendency.rota && (
                              <button
                                onClick={() => handleOpenPaymentModal(pendency)}
                                className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                title="Pagar Pendência"
                              >
                                <KTSVG
                                  path="/media/icons/duotune/finance/fin008.svg"
                                  className="svg-icon-3"
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
              <Button
                variant="secondary"
                className="btn-sm"
                onClick={() => setShowPendencyModal(false)}
              >
                Fechar
              </Button>
            </BootstrapModal.Footer>
          </BootstrapModal>

          <BootstrapModal
            show={showPaymentModal}
            onHide={() => setShowPaymentModal(false)}
            centered
          >
            <BootstrapModal.Header
              closeButton
              className="bg-success text-white pt-2 pb-2"
            >
              <BootstrapModal.Title>Informar Pagamento</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
              {selectedPendency && (
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control-sm"
                      value={selectedPendency.description}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Valor Original</Form.Label>
                    <Form.Control
                      type="number"
                      className="form-control-sm"
                      value={selectedPendency.value}
                      disabled
                    />
                  </Form.Group>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Desconto (R$)</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          className="form-control-sm"
                          value={paymentForm.discount}
                          onChange={(e) =>
                            setPaymentForm({
                              ...paymentForm,
                              discount: Number(e.target.value),
                            })
                          }
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Juros (R$)</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          className="form-control-sm"
                          value={paymentForm.interest}
                          onChange={(e) =>
                            setPaymentForm({
                              ...paymentForm,
                              interest: Number(e.target.value),
                            })
                          }
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Valor Pago (R$)</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      className="form-control-solid form-control-sm fw-bold text-success"
                      value={paymentForm.paidAmount}
                      onChange={(e) =>
                        setPaymentForm({
                          ...paymentForm,
                          paidAmount: Number(e.target.value),
                        })
                      }
                    />
                  </Form.Group>
                </Form>
              )}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
              <Button
                variant="secondary"
                className="btn-sm"
                onClick={() => setShowPaymentModal(false)}
                disabled={isLoadingPayment}
              >
                Cancelar
              </Button>
              <Button
                variant="success"
                className="btn-sm"
                onClick={handleConfirmPayment}
                disabled={isLoadingPayment}
              >
                {isLoadingPayment ? "Processando..." : "Confirmar Pagamento"}
              </Button>
            </BootstrapModal.Footer>
          </BootstrapModal>
        </div>

        <Pagination
          pagination={pagination}
          loadList={loadList}
          module={module}
          findHeaders={findHeaders}
        />
      </div>
    </div>
  );
};

export { TablesWidget11 };